import { TableConfig } from '../../../../interfaces/table-config.interface';

// Configuraciones de tabla
//Volantes de pago
export const paystubConfig: TableConfig = {
  columns: [
    { key: 'producerCode', label: 'Código', sortable: true },
    { key: 'producerName', label: 'Nombre', sortable: true },
    { key: 'producerType', label: 'Tipo', sortable: true },
    { key: 'currency', label: 'Moneda', sortable: true },
    { key: 'cutDate', label: 'Fecha Corte', sortable: true, type: 'date' },
    { key: 'grouping', label: 'Agrupamiento', sortable: true },
    { key: 'ammount', label: 'Monto', sortable: true, type: 'currency' },
  ],
  showTotals: true,
  totalFields: ['ammount'],
};

//Detalles de comisiones
export const detailsConfig: TableConfig = {
  columns: [
    { key: 'policyNumber', label: 'Póliza', sortable: true },
    { key: 'clientName', label: 'Cliente', sortable: true },
    {
      key: 'grossPremium',
      label: 'Prima Bruta',
      sortable: true,
      type: 'currency',
    },
    {
      key: 'netPremium',
      label: 'Prima Neta',
      sortable: true,
      type: 'currency',
    },
    { key: 'commission', label: 'Comisión', sortable: true, type: 'currency' },
    {
      key: 'originalPaymentCurrency',
      label: 'Tasa Origen de Pago',
      sortable: true,
      type: 'percentage',
    },
    {
      key: 'commissionRate',
      label: 'Tasa',
      sortable: true,
      type: 'percentage',
    },
    { key: 'wDate', label: 'Fecha', sortable: true, type: 'date' },
    { key: 'currencyName', label: 'Moneda', sortable: true },
    { key: 'document', label: 'Documento', sortable: true },
  ],
  showTotals: true,
  totalFields: ['netPremium', 'commission'],
};

//Detalles de comisiones por cobro
export const collectionsConfig: TableConfig = {
  columns: [
    { key: 'policyNumber', label: 'Póliza', sortable: true },
    { key: 'clientName', label: 'Cliente', sortable: true },
    {
      key: 'grossPremium',
      label: 'Prima Bruta',
      sortable: true,
      type: 'currency',
    },
    {
      key: 'coverageValue',
      label: 'Valor Cobertura',
      sortable: true,
      type: 'currency',
    },
    { key: 'comision', label: 'Comisión', sortable: true, type: 'currency' },
    { key: 'wDate', label: 'Fecha', sortable: true, type: 'date' },
    { key: 'gCovDescription', label: 'Descripción', sortable: true },
  ],
  showTotals: true,
  totalFields: ['coverageValue', 'comision'],
};
